import React from 'react';
import { Link } from 'react-router';
import SVGImage from './SVGImage';

interface MenuItemProps {
  text: string;
  icon: string;
  link: string;
  isSelected?: boolean;
  isActive?: boolean;
  isOperation?: boolean;
  className?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({
  text,
  icon,
  link,
  isSelected,
  isActive,
  isOperation,
  className,
}) => {
  const defaultLink = isOperation ? '/operation/settlement' : '/forecast';

  return (
    <Link to={isActive ? link : defaultLink}>
      <div
        className={`flex cursor-pointer items-center rounded-[5px] py-[12px] pl-[20px] ${isSelected ? '[&]:bg-teal-main' : ''} ${isOperation ? 'bg-dark-2' : 'bg-white'} ${className}`}
      >
        <SVGImage
          width={18}
          height={18}
          fill={isSelected ? 'white' : isOperation ? '#98A2AB' : '#9EBAB4'}
          name={icon}
        ></SVGImage>
        <p
          className={`pop-menu-normal ml-[12px] ${isOperation ? 'text-light-1' : 'text-dark-9'} ${isSelected ? '[&]:pop-menu-bold [&]:text-white' : ''} `}
        >
          {text}
        </p>
      </div>
    </Link>
  );
};

export default MenuItem;
